// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Landing{
  display: grid;
  grid-template-columns: auto 1fr;
  font-size: 2rem;
  height: 100%;
  gap: 12px;
}
.teams{
  text-align: left;
  white-space: pre-line;
}
.teams-dates-boxes{
  text-align: center;
  min-width: 0;
}
.__landing__row {
  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);
  border-radius: 2px;
  padding: 0.4rem 1rem;
  background: #ffffff;
  width: 100%;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.__landing__row__title {
  color: var(--primary);
  font-weight: 500;
  font-size: var(--title);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/Landing.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX","sourcesContent":[".Landing{\n  display: grid;\n  grid-template-columns: auto 1fr;\n  font-size: 2rem;\n  height: 100%;\n  gap: 12px;\n}\n.teams{\n  text-align: left;\n  white-space: pre-line;\n}\n.teams-dates-boxes{\n  text-align: center;\n  min-width: 0;\n}\n.__landing__row {\n  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);\n  border-radius: 2px;\n  padding: 0.4rem 1rem;\n  background: #ffffff;\n  width: 100%;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.__landing__row__title {\n  color: var(--primary);\n  font-weight: 500;\n  font-size: var(--title);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
